export default "__VITE_ASSET__DMVcq725__"